import { Evaluation } from '@/models/evaluations';

import { formatDate } from '../datesAndTime';

export const convertFormToParameters = (
  form: Evaluation.Form
): Evaluation.ParametersToPost => {
  const {
    choosenCreators,
    dates,
    followersRange,
    keywordQuery,
    highlightedKeywords,
    platforms,
    platformDisclosure,
    mediaType,
    requestedServices,
    logos,
    urls,
    tags,
    hashtags
  } = form;

  return {
    keywordQuery: keywordQuery?.elements?.length ? keywordQuery : null,
    highlightedKeywords: highlightedKeywords ?? [],
    creators: choosenCreators
      .filter((creator) => creator.type === 'Creators')
      .flatMap((creator) => creator.id),
    creatorGroups: choosenCreators
      .filter((creator) => creator.type === 'Groups')
      .flatMap((creator) => creator.id),
    platforms,
    followersRange,
    platformDisclosure,
    ...(mediaType !== 'all' && { mediaType }),
    startCreationDate: String(formatDate(dates[0], 'yyyy-MM-dd')),
    ...(dates[1] && {
      endCreationDate: String(formatDate(dates[1], 'yyyy-MM-dd'))
    }),
    requestedServices,
    logos: logos ?? { hasLogo: 'any' },
    urls: urls ?? { hasLinks: 'any', patterns: [] },
    tags: tags ?? [],
    hashtags: hashtags ?? []
  };
};

export const convertParametersToForm = (
  parameters: Evaluation.Parameters
): Evaluation.Form => {
  const {
    platformDisclosure,
    mediaType,
    startCreationDate,
    endCreationDate,
    platforms,
    followersRange,
    keywordQuery,
    highlightedKeywords,
    creators,
    creatorGroups,
    logos,
    urls,
    tags,
    hashtags,
    requestedServices
  } = parameters;

  const form = {
    choosenCreators: [...creators, ...creatorGroups],
    keywordQuery: keywordQuery ?? {
      type: 'logicalGroup',
      operator: 'OR',
      isNegated: false,
      elements: []
    },
    highlightedKeywords: highlightedKeywords ?? [],
    dates: [
      new Date(startCreationDate),
      endCreationDate ? new Date(endCreationDate) : null
    ] as Evaluation.DateRange,
    platforms,
    followersRange,
    platformDisclosure,
    mediaType: mediaType ?? 'all',
    requestedServices,
    logos: logos ?? { hasLogo: 'any' },
    urls: urls ?? { hasLinks: 'any', patterns: [] },
    tags: tags ?? [],
    hashtags: hashtags ?? []
  };

  return form;
};
